import { memo, useCallback } from 'react';

import { SearchResultRow } from '../components';
import type { WorkItemSearchView } from './models';
import { workItemTypeAccent } from './workItemColors';

export type WorkItemResultRowProps = {
    item: WorkItemSearchView;
    selected: boolean;
    onSelect: (item: WorkItemSearchView) => void;
};

export const WorkItemResultRow = memo(function WorkItemResultRow({ item, selected, onSelect }: WorkItemResultRowProps) {
    const handleSelect = useCallback(() => onSelect(item), [onSelect, item]);
    return (
        <SearchResultRow
            id={item.id}
            title={item.title}
            accent={workItemTypeAccent(item.workItemType, item.title)}
            typeLabel={item.workItemType}
            selected={selected}
            onSelect={handleSelect}
        />
    );
});
